import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { DropdownItem } from 'reactstrap';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selectedOne, singleSelected } from '../../../stores/tables/selectors';

interface Props extends RouteComponentProps, LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    singleSelected?: string;
}

class CopyUserAction extends React.Component<Props> {
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        const t = this.props.translate;
        if (this.props.singleSelected &&
            this.props.hasPrivilege(['ADD_USER', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.props.history.push(`/users/copy/${this.props.singleSelected}`);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'copy']} />
                        {t('users.button.copy')}
                    </DropdownItem>

                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    singleSelected: singleSelected(state, 'users'),
});

export default connect(mapStateToProps)(withRouter(withLocalize(CopyUserAction)));